(() => {
  // Menu mobile
  const header = document.querySelector('.header');
  const toggle = document.querySelector('.menu-toggle');
  if (header && toggle) toggle.addEventListener('click', () => {
    const open = header.toggleAttribute('data-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  // Carrousel d'avis : défilement horizontal, flèche « suivant ».
  document.querySelectorAll('[data-carousel]').forEach(c => {
    const track = c.querySelector('[data-track]');
    const next = c.querySelector('[data-next]');
    if (!track || !next) return;
    next.addEventListener('click', () => {
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : 300;
      const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({left: end ? 0 : track.scrollLeft + step, behavior: 'smooth'});
    });
  });

  // Ligne de stock : « se envía mañana, 21 de octubre ».
  const tomorrow = () => {
    const d = new Date(); d.setDate(d.getDate() + 1);
    return d.toLocaleDateString('es-ES', {day: 'numeric', month: 'long'});
  };

  // Fiche produit : la sélection (pack, couleur, taille) donne la variante Shopify ajoutée au panier.
  document.querySelectorAll('[data-product]').forEach(root => {
    const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const saveEl = root.querySelector('[data-save]');
    const perPair = root.querySelector('[data-per-pair]');
    const stock = root.querySelector('[data-stock]');
    const btn = root.querySelector('[data-add]');
    const hint = root.querySelector('[data-size-hint]');
    const main = root.querySelector('[data-main-image]');
    const money = c => (c / 100).toLocaleString('es-ES', {style: 'currency', currency: data.currency});
    const pairsOf = value => { const m = String(value || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; };
    const selected = data.selected.slice();
    let sizeChosen = data.sizeIndex === null;
    const show = (i, value) => i === data.sizeIndex ? String(value).replace(/-/g, '/') : value;

    const variantFor = opts => data.variants.find(v => v.options.every((o, i) => o === opts[i]));

    function render() {
      const v = variantFor(selected);
      root.querySelectorAll('[data-option-index]').forEach(group => {
        const i = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-value]').forEach(b => {
          const on = b.dataset.value === selected[i] && (i !== data.sizeIndex || sizeChosen);
          b.setAttribute('aria-pressed', String(on));
          const test = selected.slice(); test[i] = b.dataset.value;
          const tv = variantFor(test);
          b.toggleAttribute('data-unavailable', !tv || !tv.available);
        });
        const label = group.querySelector('[data-option-current]');
        if (label) label.textContent = (i === data.sizeIndex && !sizeChosen) ? 'Elige tu talla' : show(i, selected[i]);
      });
      if (data.packIndex !== null) root.querySelectorAll('[data-pack-price]').forEach(el => {
        const test = selected.slice(); test[data.packIndex] = el.dataset.packPrice;
        const tv = variantFor(test);
        if (!tv) return;
        el.querySelector('[data-pack-total]').textContent = money(tv.price);
        const n = pairsOf(el.dataset.packPrice);
        if (n) el.querySelector('[data-pack-each]').textContent = money(Math.round(tv.price / n)) + ' el par';
      });
      if (!v) { btn.disabled = true; btn.textContent = 'No disponible'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      const onSale = v.compare > v.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare); }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = 'Ahorra un ' + Math.round((v.compare - v.price) * 100 / v.compare) + ' %'; }
      if (perPair) {
        const idx = data.packIndex !== null ? data.packIndex : data.colorIndex;
        const pairs = idx === null ? 0 : pairsOf(selected[idx]);
        perPair.hidden = !(pairs > 1);
        if (pairs > 1) perPair.innerHTML = 'Solo <b>' + money(Math.round(v.price / pairs)) + '</b> el par';
      }
      if (stock) {
        stock.toggleAttribute('data-out', !v.available);
        stock.querySelector('[data-stock-label]').textContent = v.available ? stock.dataset.text + ', ' + tomorrow() : 'Agotado por ahora';
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      if (v.image && main) main.src = v.image;
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }

    root.querySelectorAll('[data-option-index]').forEach(group => {
      const i = Number(group.dataset.optionIndex);
      group.addEventListener('click', e => {
        const b = e.target.closest('[data-value]'); if (!b) return;
        selected[i] = b.dataset.value;
        if (i === data.sizeIndex) {
          sizeChosen = true;
          if (hint) { hint.classList.remove('hint--error'); hint.textContent = hint.dataset.default; }
        }
        render();
      });
    });
    // Kaching Bundles : quand une offre s'affiche, couleur et taille se choisissent dans le bloc Kaching.
    // La taille est présélectionnée pour que l'ajout au panier de Kaching ne soit jamais bloqué.
    // Le bloc reste vide sur un produit sans offre (socquettes) : le sélecteur du thème reste alors visible.
    const hasKaching = () => [...root.querySelectorAll('kaching-bundle')].some(el =>
      el.querySelector('[class*="kaching-bundles__bar"]'));
    let kachingCheck = 0;
    const applyKaching = () => {
      cancelAnimationFrame(kachingCheck);
      kachingCheck = requestAnimationFrame(() => {
        if (!hasKaching()) return;
        if (root.classList.contains('has-kaching')) return;
        root.classList.add('has-kaching');
        sizeChosen = true;
        render();
      });
    };
    new MutationObserver(applyKaching).observe(root, {childList: true, subtree: true});
    applyKaching();

    form.addEventListener('submit', e => {
      if (sizeChosen || root.classList.contains('has-kaching')) return;
      e.preventDefault();
      if (hint) {
        hint.classList.add('hint--error'); hint.textContent = 'Elige tu talla para continuar.';
        hint.scrollIntoView({block: 'center', behavior: 'smooth'});
      }
    });
    root.querySelectorAll('[data-thumb]').forEach(t => t.addEventListener('click', () => {
      main.src = t.dataset.thumb;
      root.querySelectorAll('[data-thumb]').forEach(x => x.setAttribute('aria-current', String(x === t)));
    }));
    render();
  });
})();
